<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <v-card-title>
        긴급상담 안내
        <v-btn icon @click="$emit('sheetClose')">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text class="border-none pt-0">
      <div class="text-area">
          긴급 상담이 필요하다면 <br/>
          아래 연락처를 참고해 주세요.<br/><br/>
          <ol>
            <li>
              - 자살예방 상담전화 (국번 없이) 1393
            </li>
            <li>
              - 정신건강 상담전화 1577-0199
            </li>
            <li>
              - 생명의 전화 1588-9191
            </li>
          </ol>
        </div>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import Close from '@/components/icons/Close'

export default {
  components: {
    Close
  },
  props: {
    sheet: Boolean
  },
  data: () => ({}),
  computed: {},
  methods: {}
}
</script>

